export default __webpack_public_path__ + "3da74e1cac0f315fcbc5dddc2400799c.jpg";